$(function () {
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
      $('#treatmentMenu').addClass("show");
      $('.back-to-top').show();
    } else {
      $('.header').removeClass("min-header");
      $('#treatmentMenu').removeClass("show");
      $('.back-to-top').hide();
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.back-to-top').on('click', function () {
    $('html, body').scrollTop({ top: 0}, 500);
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  $('.menu-link').click(function (e) {
    if ($(window).width() <= 1280) {
      if ($(this).hasClass('mobile-cate-show')) {
        e.preventDefault();
      }
      if ($(this).parent('.header-menu-link').hasClass('is-active')) {
        $(this).siblings('.header-menu-dropdown').slideUp(300);
        setTimeout(() => {
          $(this).parent('.header-menu-link').removeClass('is-active');
        }, 300);
      } else {
        $(this).parent('.header-menu-link').addClass('is-active');
        $(this).siblings('.header-menu-dropdown').slideDown(300, function () {
          $(this).css('height', 'auto');
        });
      }
    }
  });

  $(".header-menu-link").hover(function () {
    if ($(window).width() > 1280) {
      var isHovered = $(this).is(":hover");
      if (isHovered) {
        $(this).children('.header-menu-dropdown').stop().slideDown(300);
      } else {
        $(this).children('.header-menu-dropdown').stop().slideUp(300);
      }
    }
  });

  $(window).resize(function () {
    if ($(window).width() > 1280) {
      $('.header-menu-dropdown').slideUp(300);
      $('.header-menu-link').removeClass('is-active');
    }
  });

  // 選單群組互動邏輯 - 處理 .header-menu-dropdown.full-content
  // 桌機版：鼠標移過 .dropdown-cate
  $(".header-menu-dropdown.full-content").on('mouseenter', '.dropdown-cate', function () {
    if ($(window).width() > 1280) {
      var categoryId = $(this).data('id');
      var $dropdown = $(this).closest('.header-menu-dropdown.full-content');

      // 移除其他 .dropdown-cate 的 is-active
      $dropdown.find('.dropdown-cate').removeClass('is-active');

      // 給當前 .dropdown-cate 加上 is-active
      $(this).addClass('is-active');

      // 移除其他 .dropdown-cate-content-inner 的 is-active
      $dropdown.find('.dropdown-cate-content-inner').removeClass('is-active');

      // 給對應的 .dropdown-cate-content-inner 加上 is-active
      $dropdown.find('[data-content="' + categoryId + '"]').addClass('is-active');
    }
  });

  // 手機版：點擊 .mobile-cate
  $(".header-menu-dropdown.full-content").on('click', '.mobile-cate', function () {
    if ($(window).width() <= 1280) {
      var $contentInner = $(this).closest('.dropdown-cate-content-inner');
      var contentId = $contentInner.data('content');
      var $dropdown = $(this).closest('.header-menu-dropdown.full-content');

      // 移除所有 .dropdown-cate-content-inner 的 is-active
      $dropdown.find('.dropdown-cate-content-inner').removeClass('is-active');

      // 給當前的 .dropdown-cate-content-inner 加上 is-active
      $contentInner.addClass('is-active');

      // 移除所有 .dropdown-cate 的 is-active
      $dropdown.find('.dropdown-cate').removeClass('is-active');

      // 在 .dropdown-cates 中找到對應的 .dropdown-cate 加上 is-active
      $dropdown.find('.dropdown-cate[data-id="' + contentId + '"]').addClass('is-active');
    }
  });

  // 浮動聯絡框控制
  $('#mobileContactBtn').on('click', function (e) {
    e.stopPropagation();
    $('#floatContent').addClass('is-active');
  });

  $('.float-close').on('click', function (e) {
    e.stopPropagation();
    $('#floatContent').removeClass('is-active');
  });

  // 點擊浮動聯絡框外的地方關閉
  $(document).on('click', function (e) {
    if (!$(e.target).closest('#floatContent').length && !$(e.target).closest('#mobileContactBtn').length) {
      $('#floatContent').removeClass('is-active');
    }
  });
});

$(function () {
  // Google 轉換追蹤
  $(document).ready(function() {
    $('#contact-us-phone-btn').on('click', function(e) {
      gtag('event', 'click', {
        'event_category' : 'button',
        'event_label' : 'contact-us-phone'
      });
      fbq('track', 'Contact');

      window.uetq = window.uetq || [];
      window.uetq.push('event', 'contact-us-phone', {});
    });
  });

  $(document).ready(function() {
    $('#contact-us-phone-link').on('click', function(e) {
      gtag('event', 'click', {
        'event_category' : 'button',
        'event_label' : 'contact-us-phone'
      });
      fbq('track', 'Contact');

      window.uetq = window.uetq || [];
      window.uetq.push('event', 'contact-us-phone', {});
    });
  });

  $(document).ready(function() {
    $('#contact-us-line-btn').on('click', function(e) {
      gtag('event', 'click', {
        'event_category' : 'button',
        'event_label' : 'contact-us-line'
      });
      fbq('track', 'Contact');

      window.uetq = window.uetq || [];
      window.uetq.push('event', 'contact-us-line', {});
    });
  });

  $(document).ready(function() {
    $('#contact-us-line-link').on('click', function(e) {
      gtag('event', 'click', {
        'event_category' : 'button',
        'event_label' : 'contact-us-line'
      });
      fbq('track', 'Contact');

      window.uetq = window.uetq || [];
      window.uetq.push('event', 'contact-us-line', {});
    });
  });

  $(document).ready(function() {
    $('#contact-us-fb-btn').on('click', function(e) {
      gtag('event', 'click', {
        'event_category' : 'button',
        'event_label' : 'contact-us-fb'
      });
      fbq('track', 'Contact');

      window.uetq = window.uetq || [];
      window.uetq.push('event', 'contact-us-fb', {});
    });
  });

  $(document).ready(function() {
    $('#contact-us-fb-link').on('click', function(e) {
      gtag('event', 'click', {
        'event_category' : 'button',
        'event_label' : 'contact-us-fb'
      });
      fbq('track', 'Contact');

      window.uetq = window.uetq || [];
      window.uetq.push('event', 'contact-us-fb', {});
    });
  });

  $(document).ready(function() {
    $('#contact-us-event-bra-fat').on('click', function(e) {
      gtag('event', 'click', {
        'event_category' : 'button',
        'event_label' : 'contact-us-event-bra-fat'
      });
      fbq('track', 'Contact');

      window.uetq = window.uetq || [];
      window.uetq.push('event', 'contact-us-event-bra-fat', {});
    });
  });
});
